/* RESPONSIBLE TEAM: team-inbox-management */
import ViewSummary, { type ViewSummaryWireFormat } from '../view-summary';
import type Inbox from './inbox';
import { INBOX_DEFAULT_SORT_ORDER } from './inbox';
import { InboxCategory } from 'embercom/models/data/inbox/inbox-categories';
import { InboxType } from 'embercom/models/data/inbox/inbox-types';
import { inject as service } from '@ember/service';
import type Session from 'embercom/services/session';

export type ViewCounterWireFormat =
  | number
  | {
      count: number;
      valid_for: number;
    };

export type ViewInboxWireFormat = {
  inbox_type: InboxType.View;
  count: ViewCounterWireFormat;
  sort_order: number;
  view_summary: ViewSummaryWireFormat;
};

export default class View implements Inbox {
  @service declare session: Session;

  readonly category = InboxCategory.View;
  readonly type = InboxType.View;
  readonly sortOrder: number;
  readonly count?: number;
  readonly valid_for?: number;

  viewSummary: ViewSummary;

  constructor(count: ViewCounterWireFormat, viewSummary: ViewSummary, sortOrder?: number) {
    if (typeof count === 'object') {
      this.count = count.count;
      this.valid_for = count.valid_for;
    } else {
      this.count = count;
    }
    this.viewSummary = viewSummary;
    this.sortOrder = sortOrder ?? INBOX_DEFAULT_SORT_ORDER;
  }

  get id() {
    return this.viewSummary.id.toString();
  }

  get icon() {
    return this.viewSummary.icon;
  }

  get name() {
    return this.viewSummary.name;
  }

  get translationKey() {
    return this.viewSummary.isSystemView
      ? `inbox.inbox-list.system-view-names.${this.viewSummary.systemType}`
      : undefined;
  }

  static deserialize(json: ViewInboxWireFormat): View {
    return new View(json.count, ViewSummary.deserialize(json.view_summary), json.sort_order);
  }
}
